import { useEffect } from "react";

const useDashboardError = (response, setError) =>
    useEffect(() => {
        if (response.error) {
            setError("Sorry, we are having trouble displaying some items on your dashboard. Please contact support.")
        }
    }, [response.error])

export default useDashboardError;
